// extracted by mini-css-extract-plugin
module.exports = {"view-template":"view_template_view-template__FuzTs","note":"view_template_note__xpWZt","content":"view_template_content__rcQ6E"};